module.exports = __webpack_public_path__ + "img/mycoach.a117d22f.svg";